import { gql } from 'graphql-tag'

export const companyFragment = gql`
  fragment CompanyFragment on Company {
    id
    name
    stations {
      id
      name
    }
    users {
      id
      name
    }
  }
`
